<template>
	<div>
		<v-container>
			<v-row>
				<v-col cols="12">
					<v-breadcrumbs :items="breadcrumbs">
						<template #divider>
							<v-icon>mdi-chevron-left</v-icon>
						</template>
					</v-breadcrumbs>
				</v-col>
			</v-row>

			<v-card>
				<v-card-title>
					سياسة الخصوصية
				</v-card-title>
				<v-card-text>
					<pre>{{ privacyPolicy }}</pre>
					<v-progress-linear v-if="privacyPolicy == null" indeterminate size="128" color="primary"></v-progress-linear>
				</v-card-text>
			</v-card>

			<div class="py-5"></div>

			<v-card>
				<v-card-title>
					سياسة الإستخدام
				</v-card-title>
				<v-card-text>
					<pre>{{ termsOfUsage }}</pre>
					<v-progress-linear v-if="termsOfUsage == null" indeterminate size="128" color="primary"></v-progress-linear>
				</v-card-text>
			</v-card>
		</v-container>
	</div>
</template>

<script>
import rulesMixin from "@/mixins/rules-mixin";
import client from "@/client";

export default {
	mixins: [rulesMixin, require("@/mixins/router-mixin").default],
	data() {
		return {
			breadcrumbs: [
				{
					text: "الرئيسية",
					disabled: false,
					exact: true,
					to: { name: "home" }
				},
				{ 
					text: "سياسة الخصوصية والإستخدام",
					disabled: true 
				}
			],
			loading: true,
			privacyPolicy: null,
			termsOfUsage: null,
		};
	},
	mounted() {
		this.getInfo();
	},
	methods: {
		getInfo() {
			this.getPrivacyPolicy();
			this.getTermsOfUsage()
		},
		getPrivacyPolicy() {
			client
				.get("/api/system/privacyPolicy")
				.then(response => {
					this.privacyPolicy = response.data.data;
				})
				.finally(() => {
					this.loading = false;
				});
		},
		getTermsOfUsage() {
			client
				.get("/api/system/termsOfUsage")
				.then(response => {
					this.termsOfUsage = response.data.data;
				})
				.finally(() => {
					this.loading = false;
				});
		},
	}
};
</script>